type RequestQueryKey = string | number | boolean | null | undefined

export interface RequestQueryObject {
  [key: string]: RequestQueryKey
}

export interface RequestParamsObject {
  [key: string]: RequestQueryKey
}

export interface CreateRequestUrlParams<Q, P> {
  url: string
  query?: Q | RequestQueryObject
  params?: P | RequestParamsObject
  arrayFormats?: {
    [key: string]: 'indexed'
  }
}

// export function replaceUrlParams(
//   url: string,
//   params: Record<string, string | number | boolean | null | undefined>,
// ): string {
//   return url.replace(/:([^/?&]+)/g, (_, key) => {
//     const value = params?.[key];
//     return value !== undefined && value !== null ? String(value) : '';
//   });
// }

export function replaceUrlParams(
  url: string,
  params: Record<string, string | number | boolean | null | undefined>
): string {
  try {
    const u = new URL(url)
    u.pathname = u.pathname.replace(/:([^/?&]+)/g, (_, key) => {
      const value = params?.[key]
      return value !== undefined && value !== null ? String(value) : ''
    })
    return u.toString()
  } catch (e) {
    const parts = url.split('://')
    if (parts.length === 2) {
      const [scheme, rest] = parts
      const slashIndex = rest.indexOf('/')
      if (slashIndex !== -1) {
        const host = rest.substring(0, slashIndex)
        const path = rest.substring(slashIndex)
        const newPath = path.replace(/:([^/?&]+)/g, (_, key) => {
          const value = params?.[key]
          return value !== undefined && value !== null ? String(value) : ''
        })
        return `${scheme}://${host}${newPath}`
      }
    }
    return url.replace(/:([^/?&]+)/g, (_, key) => {
      const value = params?.[key]
      return value !== undefined && value !== null ? String(value) : ''
    })
  }
}

function appendArrayParam(
  url: string,
  key: string,
  paramValue: any[],
  arrayFormats?: Record<string, 'indexed'>
): string {
  if (arrayFormats && arrayFormats[key] === 'indexed') {
    paramValue.forEach((value: any, index: number) => {
      url += `${index > 0 ? '&' : ''}${key}[${index}]=${value ?? ''}`
    })
  } else {
    url += `${key}${paramValue.toString() !== '' ? '=' : ''}${paramValue ?? ''}`
  }
  return url
}

function appendQueryParams(
  url: string,
  query: Record<string, any>,
  arrayFormats?: Record<string, 'indexed'>
): string {
  let questionPushed = false
  let hasParams = false

  Object.keys(query).forEach((key) => {
    if (query[key] !== undefined) {
      if (!questionPushed) {
        url += '?'
        questionPushed = true
      }

      if (hasParams) {
        url += '&'
      }

      const paramValue = query[key]

      if (Array.isArray(paramValue)) {
        url = appendArrayParam(url, key, paramValue, arrayFormats)
      } else {
        url += `${key}${
          paramValue !== undefined && paramValue !== null && paramValue.toString() !== '' ? '=' : ''
        }${paramValue ?? ''}`
      }

      hasParams = true
    }
  })

  return url
}

export function createRequestUrl<Query, Params>(
  props: CreateRequestUrlParams<Query, Params>
): string {
  let url = props?.url
  const query: any = props?.query
  const params: any = props?.params
  const arrayFormats: any = props?.arrayFormats

  url = replaceUrlParams(url, params)

  if (query && typeof query === 'object') {
    url = appendQueryParams(url, query, arrayFormats)
  }

  return url
}
